import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { fetchHotel } from "../../../../../Redux/slice/features/dropdownHotelSlice";
import {
  fetchFacilities,
  saveTagFacilities,
} from "../../../../../Redux/slice/features/facilityDetailSlice";

const FacilityTag = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allHotel = useSelector((state) => state.hotels.hoteldata);
  const loading = useSelector((state) => state.hotels.loading);
  const error = useSelector((state) => state.hotels.error);
  const facilities = useSelector((state) => state.facilityDetails.facilityData);

  const [selectedHotel, setSelectedHotel] = useState("");
  const [checkedFacilities, setCheckedFacilities] = useState({});
  const [initialized, setInitialized] = useState(false);
  console.log("allHotel", allHotel);
  useEffect(() => {
    dispatch(fetchHotel());
  }, [dispatch]);

  const handleHotelChange = (e) => {
    const hotelId = e.target.value;
    console.log('selectedHotel', hotelId);
    setSelectedHotel(hotelId);
    if (hotelId) {
      setTimeout(() => {
        dispatch(fetchFacilities(hotelId));
      }, 0); // Fetch Facilities for Selected Hotel
    }
  };

  useEffect(() => {
    const checkedState = {};
    facilities.forEach((facility) => {
      checkedState[facility.FacilityID] = facility.Status === 1;
    });

    const isChanged =
      JSON.stringify(checkedState) !== JSON.stringify(checkedFacilities);
    if (isChanged) {
      console.log("Updating checked facilities");
      setCheckedFacilities(checkedState);
    } else {
      console.log("No change in facilities — skipping state update");
    }
  }, [facilities]);


  const handleCheckboxChange = (facilityId) => {
    setCheckedFacilities((prevState) => ({
      ...prevState,
      [facilityId]: !prevState[facilityId],
    }));
  };

  const handleSave = async () => {
    if (!selectedHotel) {
      alert("Please select a hotel first.");
      return;
    }
    const isAnyFacilitySelected = Object.values(checkedFacilities).some(
      (value) => value
    );

    if (!isAnyFacilitySelected) {
      alert("Please select at least one facility.");
      return;
    }

    const selectedFacilities = facilities
      .filter((facility) => checkedFacilities[facility.FacilityID])
      .map((facility) => ({
        FacilityDetailID: facility.FacilityDetailID || 0,
        FacilityID: facility.FacilityID,
      }));

    const xmlData = `
      <ArrayOfFacilityMaster>
        ${selectedFacilities
          .map(
            (facility) => `
          <FacilityMaster>
            <FacilityDetailID>${facility.FacilityDetailID}</FacilityDetailID>
            <FacilityID>${facility.FacilityID}</FacilityID>
          </FacilityMaster>`
          )
          .join("")}
      </ArrayOfFacilityMaster>
    `;

    try {
      await dispatch(
        saveTagFacilities({
          hotelId: selectedHotel,
          selectedFacilities: xmlData,
          createdBy: 1,
        })
      );
      alert("Facilities tagged successfully!");
    } catch (error) {
      console.error("Error saving facilities:", error);
      alert("Failed to save facilities.");
    }
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Tag Facility with Hotel</h3>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label text-muted">Hotel</label>
                    <select
                      className="form-control form-control-md"
                      value={selectedHotel}
                      onChange={handleHotelChange}
                      style={{maxWidth:'70%'}}
                    >
                      <option value="">Select Hotel</option>
                      {allHotel.map((hotel) => (
                        <option key={hotel.PropertyID} value={hotel.PropertyID}>
                          {hotel.UnitName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {selectedHotel && (
                  <>
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table mb-0">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Facility</th>
                            </tr>
                          </thead>
                          <tbody>
                            {facilities.length > 0 ? (
                              facilities.map((facility) => (
                                <tr key={facility.FacilityID}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={
                                        checkedFacilities[
                                          facility.FacilityID
                                        ] || false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          facility.FacilityID
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="fw-bold">
                                    {facility.FacilityTitle}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="2">No facilities found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <button
                        type="button"
                        className="btn"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilityTag;
